
<div class="container p-3">
  <h2>Counselling Assessment Report</h2>
    <div class="row">
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Session Type</mat-label>
        <mat-select [(ngModel)]="sessionType">
          <mat-option *ngFor="let t of types" [value]="t">{{t}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Select Centre</mat-label>
        <mat-select  [(ngModel)]="selectedCentre">
          <mat-option *ngFor=" let c of (_centres$|async) "
                      [value]="c.centreCode">{{c.centreName}} </mat-option>
          <!--      <mat-option  value="All">All Centres</mat-option>-->
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label >Select Name of Councelor</mat-label>
        <mat-select  aria-label="Default select example" [(ngModel)]="counselorName">
          <mat-option *ngFor="let e of (employee|async)" [value]="e.userName"> {{e.userName}}</mat-option>

        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="startDate" readonly>
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate" readonly>
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>

    </div>
  <div class="row">
    <mat-form-field appearance="legacy" class="col-md-6">
      <mat-label><span class="bi bi-search me-2"></span>Select Name</mat-label>
      <input matInput  (input)="applyFilter($event)" placeholder="Select Name" #input>
    </mat-form-field>

    <div class="col-md-6 text-end ">
      &nbsp;&nbsp;<button mat-mini-fab color="accent"  matTooltip="Search" (click)="Search()">
      <mat-icon>search</mat-icon>
    </button>&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;   <button mat-mini-fab color="accent"  (click)="clearAll()" matTooltip="Clear">
      <mat-icon>clear</mat-icon>

    </button>
    </div>
  </div>

    <section class="example-container">


  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name</th>
      <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre</th>
      <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="parentsName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Parents Name</th>
      <td mat-cell *matCellDef="let element"> {{element.parentsName}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="conducted_by">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Conducted By</th>
      <td mat-cell *matCellDef="let element"> {{element.personConductingTest}} </td>
    </ng-container>

    <ng-container matColumnDef="dateOfAssessment">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Date</th>
      <td mat-cell *matCellDef="let element"> {{(element.dateOfAssessment).toDate() | date:'dd/MM/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="primary" (click)="viewAssessment(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>

      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
      <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of users"></mat-paginator>

    </section>


</div>

